import React, { Component } from "react";
import 'simplebar';
import "./personlizeloan.scss";
import { getOfferPreFilledData } from "../../selectors";
import { connect } from "react-redux";
import { saveAgreeAndSubmit } from "../../actions/crossSellApplicationActions";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "../../analytics/adobe/index";
import { truthNLendingDataLayer } from "../../analytics/adobe/dataLayerValues";
import { getTeamData } from "../../utils/is.after";
import YorLoanDetails from "../AddBankDetails/yourLoanDetails";
import 'simplebar/dist/simplebar.css';

class Application extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      block1: true,
      block2: true,
      block3: true,
      block4: true,
      block5: true,
      block6: true,
      block7: true

    };
  }


  toggle = (index) => () => {
    this.setState({ [`block${index}`]: !this.state[`block${index}`] });
  }

  toggleExpand = (expand = false) => () => {
    this.setState({
      block1: expand,
      block2: expand,
      block3: expand,
      block4: expand,
      block5: expand,
      block6: expand,
      block7: expand
    });
  }

  render() {
    const crossSellPersonalizedQuote=this.props.offerPreFilled.crossSellPersonalizedQuote;
    const financeCharge =new Intl.NumberFormat().format(crossSellPersonalizedQuote.financeCharge);
    const loanAmount =new Intl.NumberFormat().format(crossSellPersonalizedQuote.loanAmount);
    const costOfLoan =new Intl.NumberFormat().format(crossSellPersonalizedQuote.costOfLoan);
    const monthlyPayment =new Intl.NumberFormat().format(crossSellPersonalizedQuote.monthlyPayment);
    const accordionList = [
      { title: 'APR', value: `${crossSellPersonalizedQuote.apr}%` },
      { title: 'Finance charge', value: `$${financeCharge}` },
      { title: 'Amount financed', value: `$${loanAmount}` },
      { title: 'Total of payments', value: `$${costOfLoan}` },
      { title: 'Number of payments', value: `${crossSellPersonalizedQuote.termInMonths}` },
      { title: 'Amount of payments', value: `$${monthlyPayment}` },
      { title: 'When payments are due', value: `${crossSellPersonalizedQuote.paymentDueDate}` }
    ];

    return(<div>
      <div className="cl-accordion">
        {
          accordionList.map((item, index) => (
            <Accordion key={`${item.title}-${index}`} title={item.title} value={item.value} onClick={this.toggle(index + 1)} expand={this.state[`block${index+1}`]} />
          ))
        }
      </div>
    </div>
    );
  }
}

class Accordion extends React.Component {
  render() {
    const { title, expand, onClick, value } = this.props;

    return (
      <div className="cl-listagr">
        <div className={expand ? 'title is-expanded' : 'title'} onClick={onClick}>
          {title}
        </div>
        <div className={expand ? 'content is-expanded' : 'content'} onClick={onClick}>
          {value}
        </div>
      </div>
    );

  }
}

export class Agreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      target: true,
      extraParam: false,
      showRepeatPayments: true,
      nameInputError: "",
      hasInvalidCharacters: false
    };
  }

  componentDidMount() {
    const { pageName, siteSection }=truthNLendingDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  componentWillMount() {
    let email = this.props.offerPreFilled.sign;
    this.setState({
      email: (email ? email : "")
    });
    const teamData = getTeamData(this.props.offerPreFilled.channelSource);
    if(teamData !== null){
      this.setState({
        target: teamData.target,
        extraParam: teamData.extraParam
      });
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    const hasInvalid = /[^a-zA-Z0-9\-'.\s]/.test(value);
    this.setState({
      email: value,
      hasInvalidCharacters: hasInvalid,
      nameInputError: hasInvalid ? "Only letters, numbers, and basic punctuation (- ' .) are allowed." : ""
    });
  };
  onAgreeAndSubmit = () => {
    const actionUrl = (this.props.offerPreFilled.pendFlow?"customizePendingOffer":"customizeOffer");
    const url =`/clapply/action/${actionUrl}/congrat`;
    this.props.saveAgreeAndSubmit(this.state.email, {
      mover: this.props.history,
      nextPage: url
    });
  };

  render() {
    const crossSellPersonalizedQuote=this.props.offerPreFilled.crossSellPersonalizedQuote;

    const target =(this.state.target?{ target: "_blank" }:{});
    const showpdf=(this.state.extraParam?"&showpdf=true":"");
    return (
      <div className="row">
        <div className="col-lg-5 col-sm-12 col-xs-12 col-md-6 display-bank-details-flex">
          <YorLoanDetails showRepeatPayments={this.state.showRepeatPayments} offerPreFilled={this.props.offerPreFilled} />
        </div>
        <div className="col-lg-7 col-sm-12 col-xs-12 col-md-6 padding-zero">
          <div className="section-width  col-sm-12 col-lg-12 col-md-12 col-xs-12 border-round">
            {/*<p className="standard-blue font-weight-400">
              Your loan is ready to sign
            </p>*/}
            <section className="cl-perl">
              <div className="cl-card cl-agree">
                <div className="cl-cardleading">
                  <h4 className="text-center cl-agrhead">Truth in Lending Agreement</h4>
                  <div data-simplebar data-simplebar-auto-hide="false">
                    <Application offerPreFilled={this.props.offerPreFilled}/>
                  </div>
                  <div className="text-center">
                    <a className="cl-vcd" data-track="custom-links" href={`/clapply/action/customizeOffer?truthInLending=${showpdf}`} {...target}>
                    View full agreement
                    </a>
                  </div>
                </div>
                <p className="cl-agrpara">By typing my name as it appears on my loan application, I confirm that I have
                read
                and understand the terms and conditions of this loan, and the e-consent
                conditions set forth in the loan application.</p>

                <div className="form-group">
                  <input className="form-control cl-input name-input"
                    type="text"
                    placeholder="Enter your full name"
                    aria-label="Enter your full name"
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    value={this.state.email}
                    onChange={this.handleChange}/>
                    {this.state.nameInputError && (
                        <span className="error-message" style={{ color: 'red', fontSize: '13px', display: 'block', marginTop: '5px' }}>
                        {this.state.nameInputError}
                      </span>
                    )}
                </div>

                <div className="mob-center">
                  <button type="submit" className="btn-per"
                    disabled={this.state.email.length < 1 || this.state.hasInvalidCharacters}
                    data-track="custom-links"
                    onClick={this.onAgreeAndSubmit}
                    aria-label="Click to agree and submit">
                  Agree & Submit
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  offerPreFilled: getOfferPreFilledData(state)
});

export default connect(mapStateToProps, { saveAgreeAndSubmit })(Agreement);
